'use strict';
import * as $j_app$002edata$002e$002dResource$002dKind from "./app.data.-Resource-Kind.js";
import * as $j_app$002edata$002e$002dResource$002dKind$0024$0024anon$00241 from "./app.data.-Resource-Kind$$anon$1.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ResourceKind$namedEnum$() {
  this.aFY = null;
  this.aFZ = null;
  this.aG0 = false;
  $n_Lapp_data_ResourceKind$namedEnum$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__$init$__V(this);
}
export { $c_Lapp_data_ResourceKind$namedEnum$ as $c_Lapp_data_ResourceKind$namedEnum$ };
$p = $c_Lapp_data_ResourceKind$namedEnum$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ResourceKind$namedEnum$;
/** @constructor */
function $h_Lapp_data_ResourceKind$namedEnum$() {
}
export { $h_Lapp_data_ResourceKind$namedEnum$ as $h_Lapp_data_ResourceKind$namedEnum$ };
$h_Lapp_data_ResourceKind$namedEnum$.prototype = $p;
$p.IK = (function() {
  return this.aFY;
});
$p.VV = (function(x$0) {
  this.aFY = x$0;
});
$p.bY3 = (function(a) {
  var x = $s_Lapp_data_ResourceKind$__DocumentTemplate__Lapp_data_ResourceKind();
  if ((x === a)) {
    return "document-template";
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(a);
});
$p.wy = (function() {
  if ((!this.aG0)) {
    var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcats_data_NonEmptyVector$();
    var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_Predef$().fw($m_Lapp_data_ResourceKind$().bZA());
    this.aFZ = $x_1.E4($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Vector$().aO(this$2));
    this.aG0 = true;
  }
  return this.aFZ;
});
$p.yN = (function(a) {
  return this.bY3(a);
});
var $d_Lapp_data_ResourceKind$namedEnum$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ResourceKind$namedEnum$, "app.data.ResourceKind$namedEnum$", ({
  F4: 1,
  da: 1
}));
export { $d_Lapp_data_ResourceKind$namedEnum$ as $d_Lapp_data_ResourceKind$namedEnum$ };
var $n_Lapp_data_ResourceKind$namedEnum$;
function $m_Lapp_data_ResourceKind$namedEnum$() {
  if ((!$n_Lapp_data_ResourceKind$namedEnum$)) {
    $n_Lapp_data_ResourceKind$namedEnum$ = new $c_Lapp_data_ResourceKind$namedEnum$();
  }
  return $n_Lapp_data_ResourceKind$namedEnum$;
}
export { $m_Lapp_data_ResourceKind$namedEnum$ as $m_Lapp_data_ResourceKind$namedEnum$ };
function $s_Lapp_data_ResourceKind$__DocumentTemplate__Lapp_data_ResourceKind() {
  $m_Lapp_data_ResourceKind$();
  return $t_Lapp_data_ResourceKind$__DocumentTemplate;
}
export { $s_Lapp_data_ResourceKind$__DocumentTemplate__Lapp_data_ResourceKind as $s_Lapp_data_ResourceKind$__DocumentTemplate__Lapp_data_ResourceKind };
/** @constructor */
function $c_Lapp_data_ResourceKind$() {
  this.aFR = null;
  this.aFS = null;
  this.aFT = false;
  this.aFU = null;
  this.aFV = false;
  this.aFW = null;
  this.aFX = false;
  $n_Lapp_data_ResourceKind$ = this;
  $t_Lapp_data_ResourceKind$__DocumentTemplate = new $j_app$002edata$002e$002dResource$002dKind$0024$0024anon$00241.$c_Lapp_data_ResourceKind$$anon$1("DocumentTemplate", 0);
  this.aFR = new ($j_app$002edata$002e$002dResource$002dKind.$d_Lapp_data_ResourceKind.r().C)([$s_Lapp_data_ResourceKind$__DocumentTemplate__Lapp_data_ResourceKind()]);
}
export { $c_Lapp_data_ResourceKind$ as $c_Lapp_data_ResourceKind$ };
$p = $c_Lapp_data_ResourceKind$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_ResourceKind$;
/** @constructor */
function $h_Lapp_data_ResourceKind$() {
}
export { $h_Lapp_data_ResourceKind$ as $h_Lapp_data_ResourceKind$ };
$h_Lapp_data_ResourceKind$.prototype = $p;
$p.bZA = (function() {
  return this.aFR.aS();
});
$p.brM = (function() {
  if ((!this.aFT)) {
    this.aFS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__circeCodec__Lio_circe_Codec($m_Lapp_data_ResourceKind$namedEnum$());
    this.aFT = true;
  }
  return this.aFS;
});
$p.bNu = (function() {
  if ((!this.aFV)) {
    this.aFU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NamedEnum__tapirCodec__Lsttp_tapir_Codec($m_Lapp_data_ResourceKind$namedEnum$());
    this.aFV = true;
  }
  return this.aFU;
});
$p.bsr = (function() {
  if ((!this.aFX)) {
    this.aFW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UrlConvertible$fromCodec(this.bNu(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lurldsl_errors_DummyError$().sR());
    this.aFX = true;
  }
  return this.aFW;
});
$p.dl = (function(x) {
  return x.ahL;
});
var $d_Lapp_data_ResourceKind$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ResourceKind$, "app.data.ResourceKind$", ({
  F2: 1,
  d: 1,
  D: 1
}));
export { $d_Lapp_data_ResourceKind$ as $d_Lapp_data_ResourceKind$ };
var $n_Lapp_data_ResourceKind$;
function $m_Lapp_data_ResourceKind$() {
  if ((!$n_Lapp_data_ResourceKind$)) {
    $n_Lapp_data_ResourceKind$ = new $c_Lapp_data_ResourceKind$();
  }
  return $n_Lapp_data_ResourceKind$;
}
export { $m_Lapp_data_ResourceKind$ as $m_Lapp_data_ResourceKind$ };
var $t_Lapp_data_ResourceKind$__DocumentTemplate = null;
function $u_Lapp_data_ResourceKind$__DocumentTemplate(x) {
  $t_Lapp_data_ResourceKind$__DocumentTemplate = x;
}
export { $t_Lapp_data_ResourceKind$__DocumentTemplate as $t_Lapp_data_ResourceKind$__DocumentTemplate, $u_Lapp_data_ResourceKind$__DocumentTemplate as $u_Lapp_data_ResourceKind$__DocumentTemplate };
//# sourceMappingURL=app.data.-Resource-Kind$.js.map
